
import Swal from "sweetalert2";

import Amplify, { API, graphqlOperation } from 'aws-amplify';
import * as queries from '@/graphql/queries';
import * as queries_custom from '@/graphql/queries_custom';
import * as mutations from '@/graphql/mutations';

import CrudToolbar from '@/components/Crud/Toolbar';
import CustomCrudToolbar from '@/components/Crud/CustomToolbar';
import CaseCrudToolbar from '@/components/Crud/CaseToolbar';
import accordion from '@/components/Accordion';
import CrudCheckbox from '@/components/Crud/Inputs/Checkbox';
import CrudDatepicker from '@/components/Crud/Inputs/Datepicker';
import CrudSelect from '@/components/Crud/Inputs/Select';
import CrudAutocomplete from "@/components/Crud/Inputs/Autocomplete";
import CrudText from "@/components/Crud/Inputs/Text";
import CrudJson from "@/components/Crud/Inputs/Json";
import CrudId from "@/components/Crud/Inputs/Id";
import CrudSwitch from "@/components/Crud/Inputs/Switch";
import CrudSearchModal from "@/components/Crud/Inputs/SearchModal";
import CrudSearchModalParentChild from "@/components/Crud/Inputs/SearchModalParentChild";
import CrudTextEditor from "@/components/Crud/Inputs/Texteditor";
import CrudListControl from "@/components/Crud/Inputs/ListControl";

export default {
  components: {
    CrudAutocomplete,
    CrudToolbar,
    CustomCrudToolbar,
    CaseCrudToolbar,
    accordion,
    CrudCheckbox,
    CrudDatepicker,
    CrudSelect,
    CrudText,
    CrudJson,
    CrudId,
    CrudSwitch,
    CrudSearchModal,
    CrudSearchModalParentChild,
    CrudTextEditor,
    CrudListControl
  },
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      //required: true
    },
    recordData: {
      type: Object,
      //required: true
    },
    $v: {
      type: Object,
      required: true
    },
    update: {
      type: Function,
      required: true
    },
    headerColor: {
      type: String,
      default: ""
    },
    groupIndex: {
      type: Number
    },
    orderIndex: {
      type: Number
    },
    taskCrud: {
      type: Boolean
    },
    filter: {
      type: [Array, Object],
    },
    isIframeMode: {
      type: Boolean,
      default: false,
      required: false,
    },
    iframeModelId: {
      type: String,
      default: '',
      required: false,
    },
    accountServiceItems: {
      type: [Array, Object],
      required: false
    }
  },
  data() {
    return {
      accordions: [],
      isPromisePending: false,
      gql: {
        queries: queries,
        queries_custom: queries_custom,
        mutations: mutations,
      }
    };
  },
  methods: {
    /**
     * ATLAS-1395: <Account/Service><Products> Update Add Product Dialog New
     * Pass selected serviceIds to parent component
     */
    onSelectedServices(serviceIds) {
      this.$emit("selectedServices", serviceIds);
    },
    cancel() {
      if (this.formConfig.pageMode == 'edit') {
        if (this.$v.$anyDirty) {
          Swal.fire({
            title: 'Are you sure you want to cancel?',
            text: "You have unsaved changes that will be lost.",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
          }).then((result) => {
            if (result.value) {
              //this.$router.push(this.formConfig.listPath);
              this.loadData();
            }
          })
        } else {
          this.formConfig.pageMode = 'view';
        }
      } else {
        if (true === this.isIframeMode) {
          return;
        }
        if(this.$Session.tempRedirect && this.$Session.tempRedirect != "") {
          let tempRedirect = this.$Session.tempRedirect;
          delete this.$Session.tempRedirect;
          this.$router.push(tempRedirect);
        } else {
          this.$router.push(this.formConfig.listPath);  
        }
      }

    },
    async save() {
      this.$v.$touch();
      if(this.$v.form.$invalid) {
        this.$c.log('save(): unable to save, $v.invalid');
        return;
      }

      let data = {};
      const form = this.form;
      const fields = this.formConfig.fields;
      let linkerRecordField = {};

      this.$loopo(fields, (field, name) => {
        if (!field.fields) {
          if (typeof form[name] !== 'undefined' && form[name] !== null) {
            if (field.type === 'datepicker') {
              try{
                data[name] = form[name].toUTCString();
              }catch (e) {
                data[name] = form[name].toString();
                console.log('datepicker try catch ',form[name])
              }
            } else {
              data[name] = form[name];
            }
          }
        } else {
          if (field.type === 'json') {
            const jsonFields = form[name].fields;
            Object.keys(jsonFields).map(_key => {
              if (field.fields && field.fields[_key] && field.fields[_key].removeIfEmpty) {
                if (!jsonFields[_key] || !jsonFields[_key].toString().length) {
                  delete(jsonFields[_key]);
                }
              }
            });
            data[name] = JSON.stringify(jsonFields);
          }
        }
      });

      // We should not send any empty strings on create
      if (this.formConfig.pageMode == 'new') {
        this.$loopo(fields, (field, name) => {
          if (!field.fields) {
            if (data[name] === "") {
              delete data[name];
            }
            // remove the form field which should not actually be stored in schema model record.
            if (this.formConfig.removeField) {
              delete data[this.formConfig.removeField];
            }
          } else {
            if (field.type === 'json') {
              let isEmpty = true;
              this.$loopo(field.fields, (ffield, fname) => {
                let formValue = form[name].fields[fname];
                if (formValue !== '') {
                  isEmpty = false;
                }
              });
              if (isEmpty) {
                delete data[name];
              }
            }
          }
        });
      }

      if (this.formConfig.pageMode == 'edit') {
        this.$loopo(fields, (field, name) => {
          if (!field.fields) {
            if (data[name] === "" || data[name] === undefined) {
              data[name] = null;
            }
            // remove the form field which should not actually be stored in schema model record. 
            if (this.formConfig.removeField) {
              delete data[this.formConfig.removeField];
            }
          } else {
            if (field.type === 'json') {
              let isEmpty = true;
              this.$loopo(field.fields, (ffield, fname) => {
                let formValue = form[name].fields[fname];
                if (formValue !== '') {
                  isEmpty = false;
                }
              });
              if (isEmpty) {
                data[name] = null;
              }
            }
          }
        });
      }

      //ATLAS-1235: <Service> when creating a new service the portfolio field need to be required
      if (this.formConfig.createServicePortfolioRecord) {
        linkerRecordField = {
          servicePortfolioId: data.servicePortfolioId
        }
      }

      if (this.formConfig.removeFields && this.formConfig.removeFields.length) {
        this.formConfig.removeFields.forEach(item => {
          delete data[item];
        });
      }
      
      /**
       * ATLAS-877 - Add Updatedby to all Models in the Schema
       * @see https://zeamster.atlassian.net/browse/ATLAS-877
       */
      const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByFieldName');
      if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
        data[updatedByFieldName] = this.$reduce(this, '$Session.userId');
      }

      this.$c.log('data has been prepared form = ', data);

      let query = this.getMutation(this.formConfig.pageMode === 'edit'? this.formConfig.actions.update : this.formConfig.actions.save);

      const result = await API.graphql(graphqlOperation(query, {input: data}))
        .then(result => {

          let responseKey = (this.formConfig.pageMode === 'new'? 'create' : 'update') + this.formConfig.objectName;
          let responseId = result.data[responseKey].id
          this.$c.log("success! responseKey = " + responseKey);
          this.$c.log("success! responseId = " + responseId);

          //ATLAS-1235: <Service> when creating a new service the portfolio field need to be required
          if (this.formConfig.createServicePortfolioRecord && linkerRecordField) {
            let input = {
              portfolioServicePortfolioId: linkerRecordField.servicePortfolioId,
              portfolioServiceServiceId: responseId
            };
            this.createLinkerRecord("createPortfolioService", input);
          }

          // Made changes for ATLAS-850
          if (this.formConfig.pageMode == 'edit') {
            this.loadData(result.data[responseKey]);
          }
          this.formConfig.pageMode = 'view';
          if (true === this.isIframeMode) {
            return;
          }
          this.$router.push(this.formConfig.listPath + '/' + responseId);
        })
        .catch(error => {
          this.$c.log(error);
          this.$set(this.formConfig, 'formErrors', error);
        });

    },
    getMutation(name) {
      let result = false;
      if (name) {
        if (typeof this.gql.mutations[name] !== 'undefined') {
          result = this.gql.mutations[name];
        }
      }
      return result;
    },
    getQuery(name) {
      let result = false;
      if (name) {
        if (typeof this.gql.queries_custom[name] !== 'undefined') {
          result = this.gql.queries_custom[name];
        } else if (typeof this.gql.queries[name] !== 'undefined') {
          result = this.gql.queries[name];
        }
      }
      return result;
    },
    async loadData(data) {
      let query = this.getQuery(this.formConfig.actions.new);
      let params = {};

      if (true === this.isIframeMode) {
        if (this.iframeModelId) {
          this.$c.log('loadData() - id detected:' + this.iframeModelId);
          query = this.getQuery(this.formConfig.actions.edit);
          params = { id: this.iframeModelId };
        }
      } else if (this.$route.params.id) {
        const { id } = this.$route.params;
        this.$c.log('loadData() - id detected:' + id);
        query = this.getQuery(this.formConfig.actions.edit);
        params = {id: id}; 
      }

      if (this.formConfig.limit) {
        this.$loopo(this.formConfig.limit, (field, name) => {
          params[name] = field        
        });        
      }

      if (this.formConfig.casesFilter) {
        params.casesFilter = this.formConfig.casesFilter;
      }
      if (this.formConfig.caseLinksFilter) {
        params.caseLinksFilter = { [this.formConfig.caseLinksFilter]: {eq: this.$route.params.id}}
      }
      if (this.formConfig.productOptionChildFilter && this.formConfig.productOptionParentFilter) {
        params.productOptionChildFilter = {esQuery: JSON.stringify
          ({bool:
            {
              must:[{bool:{should:[{match_phrase:{[this.formConfig.productOptionChildFilter]:this.$route.params.id}},
                                   {match_phrase:{[this.formConfig.productOptionParentFilter]:this.$route.params.id}}
                     ]}}]          
            }
          })
        }       
      }      
      if (this.formConfig.messagesFilter) {
        params.commentsFilter = this.formConfig.messagesFilter;
        params.messagesFilter = this.formConfig.messagesFilter;
        params.notesFilter = this.formConfig.messagesFilter;
        params.caseTemplatesFilter = this.formConfig.messagesFilter;
      }

      let operation = graphqlOperation(query, params);

      this.$c.log("recordData operation: ", operation);

      await API.graphql(operation)
        .then(result => {
          this.$c.log("loadData() query success, calling update function in parent...", result.data);
          this.update(result.data);
        })
        .catch(error => {
          this.$c.warn(error);
        });
    },
    async createLinkerRecord(queryId, input) {
      let linkerQuery = this.getMutation(queryId);

      await API.graphql(graphqlOperation(linkerQuery, {input: input}))
        .then(res => {
          this.$c.log(res);
        })
        .catch(err => {
          this.$c.log(err);
        })
    },
    collapseAllAccordions() {
      if (this.accordions.length) {
        this.$loopo(this.accordions, (item, index) => {
          item.active = false;
        });
      }
    },
    expandAllAccordions() {
      if (this.accordions.length) {
        this.$loopo(this.accordions, (item, index) => {
          item.active = true;
        });
      }
    },
    async refresh() {
      this.isPromisePending = true;
      this.recordData = null;
      this.loadData().then(() => {
        this.isPromisePending = false;
        this.formConfig.refreshRecordData = false;
      });
    }
  },
  async mounted() {
    this.$c.log("beforeCreate()");

    this.isPromisePending = true;
    this.loadData().then(() => {
      this.isPromisePending = false;
    });
  },
  computed: {
    dataNeedsUpdate: function () {
      return this.formConfig.refreshRecordData;
    }
  },
  watch: {
    /** this makes sure the right data is loaded if manually changing URL or flipping through search results in SPA */
    '$route' (to, from) {
      if (to.params.id !== from.params.id) {
        this.isPromisePending = true;
        this.loadData().then(result => {
          this.isPromisePending = false;
        });
      }
    },
    'dataNeedsUpdate' (to) {
      if (to === true) {
        this.refresh();
      }
    },
    'iframeModelId': {
      handler: function() {
        this.isPromisePending = true;
        this.refresh();
      }
    }
  }
};
